import {of as observableOf, Observable, BehaviorSubject } from 'rxjs';
import {catchError, tap} from 'rxjs/operators';
import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';
import { environment } from '@environments/environment';
import { ErrorResponse, SuccessResponse } from '@shared/services/api/legacy/response';
import { ICompanySettings, IDataPrivacySettings, IPermission, ISettings, IUnsubscribeSettings } from '@shared/services/api/legacy/settings-service/setting-model';
import { IFromReplyto } from '../timelines-service/timeline-model';

@Injectable({providedIn: 'root'})

export class SettingsService {
    constructor(private http: HttpClient) { }

    private permissions = new BehaviorSubject<IPermission>(null);
    public permissions$ = this.permissions.asObservable();

    private static get URL(): string { return `${environment.api.baseUrl}${environment.api.prefix}/${SettingsService.ENDPOINT}`; }
    private static get DASHBOARD_URL(): string { return `${environment.dashboardApi.baseUrl}${environment.dashboardApi.prefix}${SettingsService.ENDPOINT}`; }
    private static readonly ENDPOINT = 'settings';

    public getSubscriptions(): Observable<SuccessResponse<ISettings> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<ISettings>>(SettingsService.URL + '/subscriptions').pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getPermission(): Observable<SuccessResponse<IPermission> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<IPermission>>(SettingsService.DASHBOARD_URL + '/permissions').pipe(
        tap(res => this.permissions.next(res?.data)),
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getCompanySettings(): Observable<SuccessResponse<ICompanySettings> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<ICompanySettings>>(SettingsService.URL + '/companies').pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public setCompanySettings(companySettings: ICompanySettings): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .patch<SuccessResponse<boolean>>(SettingsService.URL + '/companies', companySettings).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getDataPrivacySettings(): Observable<SuccessResponse<IDataPrivacySettings> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<IDataPrivacySettings>>(SettingsService.URL + '/dataprivacies').pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getUnsubscribeSettings(): Observable<SuccessResponse<IUnsubscribeSettings> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<IUnsubscribeSettings>>(SettingsService.URL + '/unsubscribes').pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public setDataPrivacySettings(dataPrivacySettings: IDataPrivacySettings): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .patch<SuccessResponse<boolean>>(SettingsService.URL + '/dataprivacies', dataPrivacySettings).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public setUnsubscribeSettings(unsubscribeSettings: IUnsubscribeSettings): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .patch<SuccessResponse<boolean>>(SettingsService.URL + '/unsubscribes', unsubscribeSettings).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public getSenderSettings(): Observable<SuccessResponse<IFromReplyto> | ErrorResponse> {
        return this.http
        .get<SuccessResponse<IFromReplyto>>(SettingsService.URL + '/senders').pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public addSenderSettings(senderSettings: IFromReplyto): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .post<SuccessResponse<boolean>>(SettingsService.URL + '/senders', senderSettings).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }

    public setSenderSettings(senderSettings: IFromReplyto): Observable<SuccessResponse<boolean> | ErrorResponse> {
        return this.http
        .patch<SuccessResponse<boolean>>(SettingsService.URL + '/senders', senderSettings).pipe(
        catchError(error => observableOf(new ErrorResponse(error.error))));
    }
}
